import React from "react";
import PropTypes from "prop-types";

const buttonStyle =
  "px-6 py-3 rounded-lg transition duration-200 font-medium w-40";
const buttonStyle1 =
  "w-full px-6 py-3 rounded-lg transition duration-200 font-medium";

function FormNavButtons({ step, onContinue, onBack, copy }) {
  return (
    <div className="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 w-full">
      {step === 1 && (
        <div className="w-full">
          <button
            type="button"
            onClick={() => onContinue(step + 1)}
            className={`${buttonStyle1} bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white w-full cursor-pointer`}
          >
            {copy.buttons.continue}
          </button>
        </div>
      )}

      {step > 1 && (
        <>
          <div className="w-full md:w-40 order-2 md:order-1">
            <button
              type="button"
              onClick={onBack}
              className={`${buttonStyle1} md:${buttonStyle} bg-gray-300 text-gray-700 hover:bg-gray-400 w-full cursor-pointer`}
            >
              {copy.buttons.back}
            </button>
          </div>

          <div className="w-full md:w-40 order-1 md:order-2">
            {step < 3 ? (
              <button
                type="button"
                onClick={() => onContinue(step + 1)}
                className={`${buttonStyle1} md:${buttonStyle} bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white w-full cursor-pointer`}
              >
                {copy.buttons.continue}
              </button>
            ) : (
              <button
                type="submit"
                className={`${buttonStyle1} md:${buttonStyle} bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white w-full cursor-pointer`}
              >
                {copy.buttons.submit}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}

FormNavButtons.propTypes = {
  step: PropTypes.number.isRequired,
  onContinue: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  copy: PropTypes.shape({
    buttons: PropTypes.shape({
      continue: PropTypes.string.isRequired,
      back: PropTypes.string.isRequired,
      submit: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default React.memo(FormNavButtons);
